import { gql } from "@urql/core";

import { query } from "@/services/lukita";

export default function projectStatementsQuery({
  slug,
  accountId,
  requestOptions = {},
}) {
  return query(
    gql`
      query ProjectStatementsQuery($slug: String!, $accountId: ID!) {
        project(slug: $slug, accountId: $accountId) {
          __typename
          items: statements {
            __typename
            id
            status
            fileName
            fileUrl
            kind
            status
            numberOfPages
            createdAt
          }
          metadata: statementsMetadata {
            numberOfPages
            count
          }
        }
      }
    `,
    {
      slug,
      accountId,
    },
    {
      additionalTypenames: ["StatementRecord", "ProjectRecord"],
      ...requestOptions,
    },
  );
}
